import PageShell from "@/components/feature/PageShell";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import SearchBand from "./components/SearchBand";
import CategoryEntry from "./components/CategoryEntry";
import HotWorks from "./components/HotWorks";
import LatestWorks from "./components/LatestWorks";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useDocumentMeta({
    title: "妻子的姐姐影视大全_剧情介绍与在线观看平台",
    description:
      "妻子的姐姐网站提供丰富的影视资源，涵盖电影和电视剧的剧情介绍、演员信息与更新资讯，满足用户对相关影视作品的全面了解需求。",
    keywords: "妻子的姐姐,影视大全,剧情介绍,电视剧,电影,影视资源,演员信息,影视更新",
  });

  return (
    <PageShell>
      <HeroCarousel />
      <SearchBand />
      <div className="animate-fade-up">
        <CategoryEntry />
      </div>
      <HotWorks />
      <LatestWorks />
      <SiteIntro />
    </PageShell>
  );
}